import { render, staticRenderFns } from "./AdjuntosInformePopup.vue?vue&type=template&id=5c72ed7f&scoped=true&"
import script from "./AdjuntosInformePopup.vue?vue&type=script&lang=js&"
export * from "./AdjuntosInformePopup.vue?vue&type=script&lang=js&"
import style0 from "./AdjuntosInformePopup.vue?vue&type=style&index=0&id=5c72ed7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c72ed7f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBadge,
  VBtn,
  VChip,
  VDataTable,
  VDialog,
  VTooltip,
})
